import { endpoints } from "../config";
import { getData, postData, putData, deleteData } from "./api-utils";
import { getToken } from "./authMethods";
/**
 *
 *
 *  SCHOOL
 *
 *
 */
export const getSchool = async () => {
  return await getData(endpoints.school);
};
export const postSchool = async (values) => {
  return await postData(endpoints.school, values);
};
export const updateSchool = async (values, schoolId) => {
  return await putData(endpoints.school + "/" + schoolId, values);
};
export const deleteSchool = async (schoolId) => {
  return await deleteData(endpoints.school + "/" + schoolId);
};

/**
 *
 *
 * SCHOOL CREDITS
 *
 *
 */
export const getSchoolCredits = async (schoolId) => {
  return await getData(endpoints.schoolCredits + "/" + schoolId);
};

/**
 *
 *
 * SCHOOL GROUP
 *
 *
 */
export const getSchoolGroup = async (schoolId) => {
  return await getData(endpoints.schoolGroup + "/" + schoolId);
};
export const postSchoolGroup = async (values, schoolId) => {
  return await postData(endpoints.schoolGroup + "/" + schoolId, values);
};
export const updateSchoolGroup = async (values, groupId) => {
  return await putData(endpoints.schoolGroup + "/" + groupId, values);
};
export const deleteSchoolGroup = async (groupId) => {
  return await deleteData(endpoints.schoolGroup + "/" + groupId);
};

export const enablePracticeToGroup = async (groupId) => {
  return await postData(endpoints.enablePracticeToGroup + "/" + groupId);
};

/**
 *
 *
 * SCHOOL LESSON
 *
 *
 */

export const getLesson = async (studentId, teacherId, schoolId) => {
  const params = new URLSearchParams();

  studentId && params.append("student", studentId);
  teacherId && params.append("teacher", teacherId);
  schoolId && params.append("school", schoolId);

  return await getData(endpoints.schoolLesson + "?" + params);
};

export const postLesson = async (values) => {
  return await postData(endpoints.schoolLesson, values);
};
export const updateLesson = async (lessonId, values) => {
  return await putData(endpoints.schoolLesson + "/" + lessonId, values);
};
export const deleteLesson = async (lessonId) => {
  return await deleteData(endpoints.schoolLesson + "/" + lessonId);
};

/**
 *
 *
 * SCHOOL CATEGORY
 *
 *
 */

export const getCategory = async () => {
  return await getData(endpoints.category);
};

/**
 *
 *
 * ORDER
 *
 *
 */

export const getOrder = async (schoolId, studentId, orderId) => {
  const query = new URLSearchParams();

  schoolId && query.append("school", schoolId);
  studentId && query.append("student", studentId);
  orderId && query.append("order", orderId);

  return await getData(endpoints.order + "?" + query);
};
export const updateOrder = async (orderId, values) => {
  return await putData(endpoints.order + "/" + orderId, values);
};

export const getStudentImage = async (id) => {
  return await getData(endpoints.studentImage + "/" + id);
};

/**
 *
 *
 * DOC
 *
 *
 */

export const getDocument = (docType, order, price, hour, group, date) => {
  const params = new URLSearchParams();

  params.append("contractType", docType);
  order && params.append("price", price);
  hour && params.append("hour", hour);
  group && params.append("group", group);
  params.append("jwt", getToken());
  order && params.append("order", order);
  date && params.append("examDate", date);

  return endpoints.docGeneration + "?" + params.toString();
};
